import { TFeature } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { selectFeature } from '../selectFeature/selectFeature';
import { markAsViewed } from '../viewed/markAsViewed';

export interface IOpenOfferPreviewDeps {
  isDetailed: boolean;
  precision: number;
}

export function openOfferPreview(
  feature: TFeature,
  { isDetailed, precision }: IOpenOfferPreviewDeps,
): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const cianId = feature.properties.offers[0]?.cianId;

    if (!cianId) {
      context.logger.error('Не найден cianId для открытия preview объявления', {
        domain: 'actions/features/openOfferPreview',
        featureId: feature.id,
      });

      return;
    }

    dispatch(selectFeature(feature, precision));

    if (!feature.properties.offers[0].isViewed) {
      await dispatch(markAsViewed({ feature, offerId: cianId, precision, isDetailed }));
    }
  };
}
